module.exports = __webpack_public_path__ + "img/nukli_logo.de72472a.png";